var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.481,
    height: 55.341,
    viewBox: "0 0 49.481 55.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a61c14;stroke:#a61c14;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27.102 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.352)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.664 8.778)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M370.726,91.422a1.071,1.071,0,0,1-1.071-1.071V83.027a1.071,1.071,0,1,1,2.142,0v7.324A1.071,1.071,0,0,1,370.726,91.422Z",
    transform: "translate(-369.655 -81.956)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.66 5.332)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.071,
    cy: 1.071,
    r: 1.071
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M76.333,11.253A11.245,11.245,0,0,0,58.25,2.319h-27a3.9,3.9,0,0,0-3.9,3.9V45.181a3.9,3.9,0,0,0,3.9,3.9h3.4v1.864a3.9,3.9,0,0,0,3.9,3.9H66.552a3.9,3.9,0,0,0,3.9-3.9V36.086a1.071,1.071,0,1,0-2.142,0V50.943A1.758,1.758,0,0,1,66.552,52.7H38.547a1.758,1.758,0,0,1-1.756-1.756V49.079H59.256a3.9,3.9,0,0,0,3.9-3.9V22.34a11.292,11.292,0,0,0,5.155-.306V26.4a1.071,1.071,0,1,0,2.142,0V21.14a11.263,11.263,0,0,0,5.883-9.888ZM61.012,45.181a1.758,1.758,0,0,1-1.756,1.756H31.25a1.758,1.758,0,0,1-1.756-1.756V6.217A1.758,1.758,0,0,1,31.25,4.461H56.118a11.194,11.194,0,0,0-2.276,6.317H35.6a1.071,1.071,0,0,0-1.071,1.071v4.524A1.071,1.071,0,0,0,35.6,17.443H54.9a1.066,1.066,0,0,0,.648-.218,11.317,11.317,0,0,0,5.46,4.518ZM53.832,12.92V15.3H36.673V12.92Zm11.251,7.443a9.111,9.111,0,1,1,9.108-9.111A9.12,9.12,0,0,1,65.083,20.363Z",
    transform: "translate(-27.352)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.958 30.156)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M410.811,283.681a1.071,1.071,0,1,1,1.043-.828A1.081,1.081,0,0,1,410.811,283.681Z",
    transform: "translate(-409.742 -281.541)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.179 21.169)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.749,199.775h-19.3a1.071,1.071,0,1,1,0-2.142h19.3a1.071,1.071,0,1,1,0,2.142Z",
    transform: "translate(-94.377 -197.633)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.08)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.749,247.205h-19.3a1.071,1.071,0,1,1,0-2.142h19.3a1.071,1.071,0,1,1,0,2.142Z",
    transform: "translate(-94.377 -245.063)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.161)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.749,294.635h-19.3a1.071,1.071,0,1,1,0-2.142h19.3a1.071,1.071,0,1,1,0,2.142Z",
    transform: "translate(-94.377 -292.493)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.241)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.749,342.065h-19.3a1.071,1.071,0,1,1,0-2.142h19.3a1.071,1.071,0,1,1,0,2.142Z",
    transform: "translate(-94.377 -339.923)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfoIcon);
export default __webpack_public_path__ + "static/media/contactInfoIcon.ed8a5d96f4405bbbcdd576bc91135a83.svg";
export { ForwardRef as ReactComponent };